

import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { CourseListResponse, getCourses } from "../../../../api/courses";

interface UseCoursesListParams {
  initialPage?: number;
  initialLimit?: number;
  isAdmin?: boolean;
  type?: string
}

export const useCourseList = ({
  initialPage = 1,
  initialLimit = 10,
  isAdmin = true,
  type = 'Course'
}: UseCoursesListParams) => {
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  const [search, setSearch] = useState('');

  // Reset page to 1 whenever search changes
  useEffect(() => {
    setPage(1);
  }, [search, type]);

  const responseQuery = useQuery<CourseListResponse>({
    queryKey: ["admin-courses", { page, limit, search, type }],
    queryFn: () =>
      getCourses(
        { page, limit, search, ...(type === 'all' ? {} : { type }) },
        isAdmin,
      ),
    refetchInterval: 60000,
    refetchIntervalInBackground: true,
  });

  const onPaginationChange = (pagination: { current: number; pageSize: number }) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  return {
    ...responseQuery,
    page,
    limit,
    search,
    setSearch,
    onPaginationChange,
  };
};